// extracted by mini-css-extract-plugin
export default {"container":"webpack-concepts-Extraction-Blocks-Subheading-editor-SubheadingEditor-module__container"};